module.exports = __webpack_public_path__ + "static/vpn-kernel-90b384824632bd33f718e59365ac67dd.svg";